export const ACCESS_TOKEN = 'access_token';
export const EXERCISE_BASKET = 'exercise_basket';
export const CURRENT_OFFICE_LOCATION = 'current_office_location';
